var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEpulseLoading3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_973_175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.87814 0C6.6358 0 6.43912 0.196679 6.43912 0.439016V5.12186C6.43912 5.3642 6.6358 5.56088 6.87814 5.56088H11.561C11.8033 5.56088 12 5.3642 12 5.12186C12 2.29781 9.70219 0 6.87814 0ZM5.12093 1.75607C2.0364 1.75665 -0.420046 4.49812 0.060238 7.6725C0.390378 9.85529 2.14471 11.6096 4.3275 11.9398C7.50188 12.42 10.2433 9.9636 10.2439 6.87907C10.2439 6.63673 10.0473 6.43891 9.80492 6.43891H6.14645C5.82304 6.43891 5.56109 6.17696 5.56109 5.85355V2.19508C5.56109 1.95275 5.36327 1.75607 5.12093 1.75607Z",
    fill: "#FEC84B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_973_175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpulseLoading3);
export default __webpack_public_path__ + "static/media/epulse-loading3.884301413570061576329ddc7a3181bd852a608d7a5df67d09b032f239808743.svg";
export { ForwardRef as ReactComponent };